

export function coordinatesIntersectWithRect(x, y, rect) {

	let träff = (
		x >= rect.x
		&& x <= rect.x + rect.width - 1

		&& y >= rect.y
		&& y <= rect.y + rect.height - 1
	);

	if (träff)
		//console.log(`# Träff x: ${x}, y: ${y}  –  rect.x: ${rect.x}, rect.y: ${rect.y}, rect.width: ${rect.width}, rect.hight: ${rect.hight}`);

	return träff;
}


//-------------------------------------------------------------------------------------------------------------------------------------

export function coordinatesIntersectWithRect_LeftHalf(x, y, rect) {

	let leftRect = new DOMRect(
		rect.x,
		rect.y,
		rect.width / 2,	// Halva!
		rect.height);

	return coordinatesIntersectWithRect(x, y, leftRect);
}


//-------------------------------------------------------------------------------------------------------------------------------------

export function coordinatesIntersectWithRect_RightHalf(x, y, rect, isLastItem) {

	// Beräknar utifrån samma metod som för *left* half ovan, för att right + left garanterat ska bli === width och att de båda halvorna garanterat inte ska överlappa varandra:
	let leftWidth = rect.width / 2;

	let rightRect = new DOMRect(
		rect.x + (rect.width - leftWidth),
		rect.y,
		(isLastItem ? 100000 : (rect.width - leftWidth)),		// Specialare: Om det är sista item ska allt tomt utrymme till höger om också ge träff.
		rect.height);

	return coordinatesIntersectWithRect(x, y, rightRect);
}


//-------------------------------------------------------------------------------------------------------------------------------------

////################################################################################################

//export const intersectWithRect = {
//	coordinatesIntersectWithRect as 
//	Vue.component('coordinatesIntersectWithRect', ResponsiveContainer)
//	Vue.directive('responsive-container', ResponsiveContainerDirective)
//};
